import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaExclamationCircle, FaUpload, FaCheck, FaTimes } from 'react-icons/fa';
import './FiqueAtentoForm.css';
import { apiGet, apiPost, apiPostForm } from '../services/api';

function FiqueAtentoForm() {
  const [unidades, setUnidades] = useState([]);
  const [locais, setLocais] = useState([]);
  const [processos, setProcessos] = useState([]);
  const [tiposRegistro, setTiposRegistro] = useState([]);
  const [potenciais, setPotenciais] = useState([]);
  const [envolvidos, setEnvolvidos] = useState([]);
  const [filteredLocais, setFilteredLocais] = useState([]);
  const [filteredProcessos, setFilteredProcessos] = useState([]);
  const [unidadeId, setUnidadeId] = useState('');
  const [localId, setLocalId] = useState('');
  const [processoId, setProcessoId] = useState('');
  const [tipoRegistroId, setTipoRegistroId] = useState('');
  const [potencialId, setPotencialId] = useState('');
  const [envolvidoId, setEnvolvidoId] = useState('');
  const [dataPoc, setDataPoc] = useState('');
  const [acaoRealizada, setAcaoRealizada] = useState('');
  const [descEvento, setDescEvento] = useState('');
  const [nomeColaborador, setNomeColaborador] = useState('');
  const [arquivo, setArquivo] = useState(null);
  const [mostrarPotencial, setMostrarPotencial] = useState(true);
  const [horaFa, setHoraFa] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [terceiroEmpresa, setTerceiroEmpresa] = useState('');
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastType, setToastType] = useState('success'); // 'success' ou 'error'

  const navigate = useNavigate();
  const colaboradorId = localStorage.getItem('colaboradorId');

  // Função para mostrar toast
  const showToastMessage = (message, type = 'success') => {
    setToastMessage(message);
    setToastType(type);
    setShowToast(true);
    
    // Auto-hide após 3 segundos
    setTimeout(() => {
      setShowToast(false);
      if (type === 'success') {
        navigate('/home');
      }
    }, 3000);
  };
  
  useEffect(() => {
    const nome = localStorage.getItem('userName');
    if (nome) {
      setNomeColaborador(nome);
    }

    if (!colaboradorId) {
      navigate('/login');
    }

    fetchUnidades();
    fetchLocais();
    fetchProcessos();
    fetchTiposRegistro();
    fetchPotenciais();
    fetchEnvolvidos();
  }, [navigate, colaboradorId]);

  const fetchUnidades = async () => {
    try {
      const { data } = await apiGet('/units');
      if (data.status === 'success') {
        const sortedUnidades = data.data.sort((a, b) => a.nome.localeCompare(b.nome));
        setUnidades(sortedUnidades);
      }
    } catch (error) {
      console.error('Erro na requisição de unidades:', error);
    }
  };

  const fetchLocais = async () => {
    try {
      const { data } = await apiGet('/locais');
      if (data.status === 'success') {
        const locaisAtivos = data.data.filter((l) => l.ativo !== 'N');
        const sortedLocais = locaisAtivos.sort((a, b) => a.nome.localeCompare(b.nome));
        setLocais(sortedLocais);
      }
    } catch (error) {
      console.error('Erro na requisição de locais:', error);
    }
  };

  const fetchProcessos = async () => {
    try {
      const { data } = await apiGet('/processos');
      if (data.status === 'success') {
        const processosAtivos = data.data.filter((p) => p.ativo !== 'N');
        const sortedProcessos = processosAtivos.sort((a, b) => a.nome.localeCompare(b.nome));
        setProcessos(sortedProcessos);
      }
    } catch (error) {
      console.error('Erro na requisição de processos:', error);
    }
  };

  const fetchTiposRegistro = async () => {
    try {
      const { data } = await apiGet('/tiporegistro');
      if (data.status === 'success') {
        setTiposRegistro(data.data);
      }
    } catch (error) {
      console.error('Erro na requisição de tipos de registro:', error);
    }
  };

  const fetchPotenciais = async () => {
    try {
      const { data } = await apiGet('/potencial');
      if (data.status === 'success') {
        setPotenciais(data.data);
      }
    } catch (error) {
      console.error('Erro na requisição de potenciais:', error);
    }
  };

  const fetchEnvolvidos = async () => {
    try {
      const { data } = await apiGet('/tipoenvolvido');
      if (data.status === 'success') {
        setEnvolvidos(data.data);
      }
    } catch (error) {
      console.error('Erro na requisição de tipos de envolvidos:', error);
    }
  };

  useEffect(() => {
    const tipoSelecionado = tiposRegistro.find((tipo) => tipo.id === parseInt(tipoRegistroId));
    if (tipoSelecionado?.nome === 'Comportamento Seguro') {
      setMostrarPotencial(false);
      setPotencialId('');
    } else {
      setMostrarPotencial(true);
    }
  }, [tipoRegistroId, tiposRegistro]);

  useEffect(() => {
    if (unidadeId) {
      const filteredLocals = locais.filter((local) => local.unidades_id === parseInt(unidadeId, 10));
      setFilteredLocais(filteredLocals);

      const filteredProcs = processos.filter((processo) => processo.unidades_id === parseInt(unidadeId, 10));
      setFilteredProcessos(filteredProcs);
    } else {
      setFilteredLocais([]);
      setFilteredProcessos([]);
    }
  }, [unidadeId, locais, processos]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Corrige o problema de fuso horário da data
    const [ano, mes, dia] = dataPoc.split('-');
    const dataCorrigida = `${ano}-${mes}-${dia}`;

    const agora = new Date();

    // Bloqueia lançamentos fora do mês/ano vigente (para fins de meta previsto/realizado)
    if (parseInt(ano, 10) !== agora.getFullYear() || parseInt(mes, 10) !== agora.getMonth() + 1) {
      showToastMessage('Não é possível registrar eventos fora do mês atual.', 'error');
      return;
    }

    setIsSubmitting(true);

    // Captura data e hora atual no formato MySQL (YYYY-MM-DD HH:MM:SS)
    const dataHoraAtual = agora.getFullYear() + '-' +
      String(agora.getMonth() + 1).padStart(2, '0') + '-' +
      String(agora.getDate()).padStart(2, '0') + ' ' +
      String(agora.getHours()).padStart(2, '0') + ':' +
      String(agora.getMinutes()).padStart(2, '0') + ':' +
      String(agora.getSeconds()).padStart(2, '0');

    const payload = {
      app_registro_id: 1,
      unidades_id: parseInt(unidadeId, 10),
      locais_id: parseInt(localId, 10),
      processos_id: parseInt(processoId, 10),
      tipo_registro_id: parseInt(tipoRegistroId, 10),
      potencial_fa_id: parseInt(potencialId, 10),
      tipo_envolvido_id: parseInt(envolvidoId, 10),
      datapoc: dataCorrigida,
      horafa: horaFa,
      data_hora: dataHoraAtual,
      terceiro: terceiroEmpresa.trim(),
      desc_evento: descEvento.trim(),
      acao_realizada: acaoRealizada.trim(),
      obser: parseInt(colaboradorId, 10),
    };

    try {
      const { response, data } = await apiPost('/registros', payload);

      if (response.ok && data.status === 'success') {
        const registroId = data.data?.id;

        if (parseInt(potencialId, 10) === 4) {
          await apiPost('/rest.php?class=PocsRestService&method=sendEmail', {
            nomeColaborador,
            dataEvento: dataPoc,
            nomeLocal: locais.find((l) => l.id === parseInt(localId))?.nome,
            nomeUnidade: unidades.find((u) => u.id === parseInt(unidadeId))?.nome,
            descricaoEvento: descEvento.trim(),
          });
        }

        if (arquivo && registroId) {
          const formData = new FormData();
          formData.append('anexo', arquivo);
          formData.append('registros_id', registroId);

          try {
            const { data: uploadResult } = await apiPostForm('/rest.php?class=PocsRestService&method=storeAnexo', formData);
            if (uploadResult.status !== 'success') {
              alert('Registro salvo, mas o anexo falhou: ' + uploadResult.message);
            }
          } catch (uploadError) {
            console.error('Erro no upload do anexo:', uploadError);
            alert('Registro salvo, mas erro no envio do anexo.');
          }
        }

        showToastMessage('Registro salvo com sucesso!', 'success');
      } else {
        showToastMessage('Erro ao enviar registro: ' + (data.message || 'Erro desconhecido'), 'error');
        setIsSubmitting(false);
      }
    } catch (error) {
      console.error(error);
      showToastMessage('Erro ao enviar registro. Tente novamente.', 'error');
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate('/home');
  };

  return (
    <div className="form-page-container">
      {/* Toast Notification */}
      {showToast && (
        <div className={`toast toast-${toastType}`}>
          <div className="toast-icon">
            {toastType === 'success' ? <FaCheck /> : <FaTimes />}
          </div>
          <span className="toast-message">{toastMessage}</span>
        </div>
      )}

      {/* Header */}
      <div className="form-header">
        <div className="form-logo">
          <FaExclamationCircle />
        </div>
        <h1>Novo Registro</h1>
        <p>Preencha as informações do evento observado</p>
      </div>

      {/* Formulário */}
      <div className="form-card">
        <div className="form-section-header">
          <h2>Informações do Evento</h2>
        </div>

        <form onSubmit={handleSubmit} className="registro-form">
          <div className="form-row">
            <div className="form-group">
              <label>Unidade <span className="required">*</span></label>
              <select
                value={unidadeId}
                onChange={(e) => setUnidadeId(e.target.value)}
                required
                className="form-control"
              >
                <option value="">Selecione uma unidade</option>
                {unidades.map((unidade) => (
                  <option key={unidade.id} value={unidade.id}>
                    {unidade.nome}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>Local <span className="required">*</span></label>
              <select
                value={localId}
                onChange={(e) => setLocalId(e.target.value)}
                required
                className="form-control"
              >
                <option value="">Selecione um local</option>
                {filteredLocais.map((local) => (
                  <option key={local.id} value={local.id}>
                    {local.nome}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Processo <span className="required">*</span></label>
              <select
                value={processoId}
                onChange={(e) => setProcessoId(e.target.value)}
                required
                className="form-control"
              >
                <option value="">Selecione um processo</option>
                {filteredProcessos.map((processo) => (
                  <option key={processo.id} value={processo.id}>
                    {processo.nome}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>Classifique o Registro <span className="required">*</span></label>
              <select
                value={tipoRegistroId}
                onChange={(e) => setTipoRegistroId(e.target.value)}
                required
                className="form-control"
              >
                <option value="">Selecione uma classificação</option>
                {tiposRegistro.map((tipo) => (
                  <option key={tipo.id} value={tipo.id}>
                    {tipo.nome}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="form-row">
            {mostrarPotencial && (
              <div className="form-group">
                <label>Potencial <span className="required">*</span></label>
                <select
                  value={potencialId}
                  onChange={(e) => setPotencialId(e.target.value)}
                  required
                  className="form-control"
                >
                  <option value="">Selecione o potencial</option>
                  {potenciais.map((potencial) => (
                    <option key={potencial.id} value={potencial.id}>
                      {potencial.nome}
                    </option>
                  ))}
                </select>
              </div>
            )}

            <div className="form-group">
              <label>Envolvido <span className="required">*</span></label>
              <select
                value={envolvidoId}
                onChange={(e) => {
                  setEnvolvidoId(e.target.value);
                  const nomeSelecionado = envolvidos.find(
                    (ev) => ev.id === parseInt(e.target.value)
                  )?.nome;
                  if (nomeSelecionado !== 'Terceiro') {
                    setTerceiroEmpresa('');
                  }
                }}
                required
                className="form-control"
              >
                <option value="">Selecione o tipo de envolvido</option>
                {envolvidos.map((envolvido) => (
                  <option key={envolvido.id} value={envolvido.id}>
                    {envolvido.nome}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {envolvidos.find((e) => e.id === parseInt(envolvidoId))?.nome === 'Terceiro' && (
            <div className="form-row">
              <div className="form-group form-group-full">
                <label>Nome da Empresa Terceira <span className="required">*</span></label>
                <input
                  type="text"
                  className="form-control"
                  value={terceiroEmpresa}
                  onChange={(e) => setTerceiroEmpresa(e.target.value)}
                  placeholder="Digite o nome da empresa"
                  required
                />
              </div>
            </div>
          )}

          <div className="form-row">
            <div className="form-group">
              <label>Data <span className="required">*</span></label>
              <input
                type="date"
                value={dataPoc}
                onChange={(e) => setDataPoc(e.target.value)}
                required
                className="form-control"
              />
            </div>

            <div className="form-group">
              <label>Hora <span className="required">*</span></label>
              <input
                type="time"
                value={horaFa}
                onChange={(e) => setHoraFa(e.target.value)}
                required
                className="form-control"
              />
            </div>
          </div>

          <div className="form-group">
            <label>Descrição do Evento <span className="required">*</span></label>
            <textarea
              className="form-control"
              value={descEvento}
              onChange={(e) => setDescEvento(e.target.value)}
              placeholder="Descreva o evento ocorrido..."
              required
              rows="4"
            ></textarea>
          </div>

          <div className="form-group">
            <label>Ação Realizada <span className="required">*</span></label>
            <textarea
              className="form-control"
              value={acaoRealizada}
              onChange={(e) => setAcaoRealizada(e.target.value)}
              placeholder="Descreva a ação realizada..."
              required
              rows="4"
            ></textarea>
          </div>

          <div className="form-group">
            <label>Anexo</label>
            <div className="file-upload">
              <input
                type="file"
                id="file-input"
                className="file-input"
                onChange={(e) => setArquivo(e.target.files[0])}
                accept=".png,.jpg,.jpeg,.pdf,.doc,.docx"
              />
              <label htmlFor="file-input" className="file-label">
                <FaUpload /> {arquivo ? arquivo.name : 'Selecionar Arquivo'}
              </label>
            </div>
          </div>

          <div className="form-actions">
            <button type="button" onClick={handleCancel} className="btn-cancel" disabled={isSubmitting}>
              Cancelar
            </button>
            <button type="submit" className="btn-save" disabled={isSubmitting}>
              {isSubmitting ? (
                <>
                  <span className="spinner-small"></span>
                  Enviando...
                </>
              ) : (
                'Salvar Registro'
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default FiqueAtentoForm;